
const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';;

export const getApiUrl = () => {
    if(!isDev){
        return "https://mktrends.azurewebsites.net/"
        //return "http://144.24.204.218"
    }
    else{
        return "http://localhost:8080/"
    }
}

export const getClientUrl = () => {
    if(!isDev){
        return "https://chitaj.web.app/"
    }
    else{
        return "http://localhost:3000/"
    }
}